var $8321ed0f8ab642f0$exports = {};
$8321ed0f8ab642f0$exports = {
  "decrease": function decrease(args) {
    return "Reducer ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "\xD8g ".concat(args.fieldLabel);
  },
  "numberField": "Talfelt"
};
export { $8321ed0f8ab642f0$exports as default };